module.exports = __webpack_public_path__ + "img/niro-21.83767f1a.png";